import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDTouchable,
    JDText
} from '@jdreact/jdreact-core-lib';

import { pt, px } from '../../common/utils';
import { promoTxt } from '../../common/enum';
import img from '../../common/img';

export default class List extends PureComponent {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        planList: []
    }

    render() {
        const { planList, goBuy, isLogin } = this.props;

        return (
            <View style={ st.allList }>
                {
                    planList.map((item, index) => {
                        return (
                            <JDTouchable key={ index } onPress={ () => { goBuy(item); } } >
                                <View style={ st.list }>
                                    <View style={ st.listMain }>
                                        <View style={ st.time }>
                                            <JDText style={ [st.tHeight, st.tTime] }>{item.startTime}</JDText>
                                            <JDText style={ st.gray }>{item.endTime} 散场</JDText>
                                        </View>
                                        <View style={ st.movie }>
                                            <JDText style={ [st.tHeight, st.tMovie] }>{item.playType}</JDText>
                                            <JDText numberOfLines={ 1 } style={ st.gray }>{item.hallName}</JDText>
                                        </View>
                                        <View style={ st.price }>
                                            <JDText style={ [st.tHeight, st.tPrice, (item.promoType >= 0 && item.promoType == 2) && { paddingTop: pt(5) }] }>
                                                <JDText style={ st.priceSymbol }>&yen;</JDText>
                                                <JDText style={ st.priceSize }>{parseFloat((item.promoPrice || item.jdPrice) / 100)}</JDText>
                                                {item?.isPartitionPrice ? <JDText style={ st.priceRise }>起</JDText> : ""}
                                            </JDText>
                                            {
                                                (item.promoType >= 0 && item.promoType == 2) && (item.jdPrice - item.promoPrice) > 0 && <JDText style={ st.blue }>{isLogin ? '新用户已减' : '新用户立减'} <JDText>&yen;{parseFloat((item.jdPrice - item.promoPrice) / 100)}</JDText></JDText>
                                            }
                                            {
                                                (item.promoType >= 0 && item.promoType != 2) && (item.jdPrice - item.promoPrice) > 0 &&
                                                <JDText style={ st.blue }>{promoTxt[item.promoType].logogram1} {true && <JDText>&yen;{parseFloat((item.jdPrice - item.promoPrice) / 100)}</JDText>}
                                                </JDText>
                                            }
                                            {/* &yen;{parseFloat(item.promoPrice/100)} */}
                                        </View>
                                        {/* <View style={st.button}>

                                            <JDImage style={st.img} source={img.border}>
                                                <JDText style={st.toBuy}>购票</JDText>
                                            </JDImage>
                                        </View> */}
                                        <View style={ st.button }>

                                            <View style={ st.border_view } source={ img.border }>
                                                <JDText style={ [st.toBuy, { marginTop: pt(4) }] }>购票</JDText>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </JDTouchable>
                        );
                    })
                }
            </View>

        );
    }
}

List.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    allList: {
        paddingBottom: pt(10),
        backgroundColor: '#fff'
    },
    // 列表样式
    list: {
        paddingLeft: pt(15)
        // paddingRight: pt(10)
    },
    listMain: {
        flexDirection: 'row',
        height: pt(66),
        width: pt(365),
        borderColor: 'rgba(0,0,0,.1)',
        borderBottomWidth: px(1),
        alignItems: 'center'
    },
    time: {
        width: pt(75),
        justifyContent: 'flex-end'
    },
    movie: {
        width: pt(95)
    },
    price: {
        alignItems: 'flex-end',
        width: pt(110),
        justifyContent: 'flex-end',
        paddingRight: pt(10)
    },
    priceRise: {
        fontSize: pt(12),
    },
    tHeight: {
        height: pt(27)
        // borderWidth: pt(1),
        // borderColor: 'red'
    },
    tTime: {
        fontSize: pt(18),
        color: '#000',
        fontWeight: '400'
    },
    tMovie: {
        fontSize: pt(11),
        color: '#000',
        alignItems: 'flex-end',
        paddingTop: pt(6)
    },
    tPrice: {
        lineHeight: pt(20),
        fontSize: pt(12),
        // color: '#E2231A',
        color: '#999999',
        // paddingTop: pt(5),
        justifyContent: 'flex-end'
    },
    priceSymbol: {
        fontSize: pt(12),
        color: '#E2231A',
        marginRight: pt(10)
    },
    priceSize: {
        fontWeight: '400',
        color: '#E2231A',
        fontSize: pt(18),
        lineHeight: pt(25)
    },
    button: {
        width: pt(72),
        alignItems: 'flex-end',
        height: pt(27)
    },
    gray: {
        color: '#898989',
        fontSize: pt(11)
    },
    blue: {
        color: '#2B84FF',
        fontSize: pt(10)
        // marginTop: pt(5),
    },
    border_view: {
        height: pt(26),
        width: pt(52),
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: pt(1),
        borderColor: '#E2231A',
        borderRadius: pt(6)
    },
    toBuy: {
        color: '#E2231A',
        fontSize: pt(13),
        width: pt(52),
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: 'transparent'
    }
});

module.exports = List;
